<template>
    <div class="accountAuth padding-20 bgc box-shadow">
            <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'accountAuth',
    data() {
        return {}
    },
    mounted() {
    },
    methods: { },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.accountAuth {
}
</style>
